var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircleBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5C4.84375 12.5 2.875 11.375 1.79688 9.5C0.71875 7.64844 0.71875 5.375 1.79688 3.5C2.875 1.64844 4.84375 0.5 7 0.5C9.13281 0.5 11.1016 1.64844 12.1797 3.5C13.2578 5.375 13.2578 7.64844 12.1797 9.5C11.1016 11.375 9.13281 12.5 7 12.5ZM6.0625 8.375C5.73438 8.375 5.5 8.63281 5.5 8.9375C5.5 9.26562 5.73438 9.5 6.0625 9.5H7.9375C8.24219 9.5 8.5 9.26562 8.5 8.9375C8.5 8.63281 8.24219 8.375 7.9375 8.375H7.75V6.3125C7.75 6.00781 7.49219 5.75 7.1875 5.75H6.0625C5.73438 5.75 5.5 6.00781 5.5 6.3125C5.5 6.64062 5.73438 6.875 6.0625 6.875H6.625V8.375H6.0625ZM7 3.5C6.57812 3.5 6.25 3.85156 6.25 4.25C6.25 4.67188 6.57812 5 7 5C7.39844 5 7.75 4.67188 7.75 4.25C7.75 3.85156 7.39844 3.5 7 3.5Z",
    fill: "#1C32F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleBlue);
export default __webpack_public_path__ + "static/media/info-circle-blue.cbf7dfe55ed423ecf528e2dbad5f0a51.svg";
export { ForwardRef as ReactComponent };